




























import {Vue, Component} from 'vue-property-decorator';
import ServiceCatalogService from '@/services/ServiceCatalogService';
import ServiceCatalogItemDTO from '@/dto/sales/catalog/ServiceCatalogItemDTO';

@Component({})
export default class ServiceCatalogItems extends Vue {
  private items: ServiceCatalogItemDTO[] = [];

  async mounted() {
    if (this.$loadOn) this.$loadOn();
    try {
      const response = await ServiceCatalogService.getCatalog();
      this.items = response.data;
    } catch (e) {
      console.error('Failed to load service catalog', e);
    } finally {
      if (this.$loadOff) this.$loadOff();
    }
  }

  private formatPrice(priceCents: number | null): string {
    if (priceCents === null || priceCents === undefined) {
      return '—';
    }
    return `$${(priceCents / 100).toFixed(2)}`;
  }
}
